import styled from "styled-components";

export const StyledAlgorithmLogo = styled.img`
  min-width: 40px;
  width: 40px;
  height: 40px;
  margin: ${({ theme }) => theme.space.xs} ${({ theme }) => theme.space.sm} 0 0;
`;

export const StyledViewAllUpdates = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const StyledDialogContent = styled.div`
  margin: 0 ${({ theme }) => theme.space.md};
`;

export const StyledFooter = styled.div`
  height: 1rem;
`;
